import { render, staticRenderFns } from "./ButtonCreate.vue?vue&type=template&id=a5b83efc"
import script from "./ButtonCreate.vue?vue&type=script&lang=js"
export * from "./ButtonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports